import IAppMetadata from '@/interfaces/IAppMetadata';

const APP_METADATA: IAppMetadata = {
  app_token: "",
  app_info_name: "crm-ft-ui-kbs-content-scrape",
  app_info_released_on: "Mon, 13 Apr 2026 12:43:14 GMT",
  app_info_branch: "master",
  app_info_commitShortHash: "83fa775",
  app_info_env: "Development",
  app_info_version: "0.10.9",
  google_analytics_id: "G-4JH31Q8XS4",
};

export default APP_METADATA;